import React, {useEffect, useState} from "react"
import PropTypes from "prop-types"
import CartContext, {CartItem} from "../context/CartContext"
import {useRouter} from "next/router"
import {cartTypeGuard} from "../utility/typeGuards"

const localStorageItemName = "cart"
const localStorageCartStatus = "cartCountDown"
export const timerStart = 1200

type Props = {
    children: React.ReactNode
}

const storeCart = (items: CartItem[]) => {
	if (typeof window !== undefined) {
		localStorage.setItem(localStorageItemName, JSON.stringify(items))
	}
}

const getCart = () => {
	if (typeof window !== undefined) {
		try {
			const cart = localStorage.getItem(localStorageItemName)
			if (cart !== null) {
				const cartArray = JSON.parse(cart)
				return cartTypeGuard(cartArray)
			}
		} catch (error) {
			console.error("Cart Item is too old", error)
			return []
		}

		console.error("Cart Item Doesn't match needed type")
		return []
	}

	return []
}

export const getCartStatus = () => {
	if (typeof window !== undefined) {
		const cart = localStorage.getItem(localStorageCartStatus)
		if (cart !== null) {
			return JSON.parse(cart)
		}
	}

	return {
		count: "0",
		time: "00:00:00",
		startTimer: timerStart
	}
}

const CartContextProvider: React.FC<Props> = ({children}) => {
	const [items, setItems] = useState<CartItem[]>([])
	const router = useRouter()
	useEffect(() => {
		setItems(getCart())
	}, [router.asPath])

	const addItem = (item: CartItem) => {
		setItems(prevItems => [
			...prevItems,
			item
		])
	}

	const removeItem = (item: CartItem) => {
		// Redistribute down payment of removed item to all other items
		let amountToAddToEveryItem = 0
		for (const item of items) {
			amountToAddToEveryItem = item.downPayment ? item.downPayment / (items.length - 1) : 0
		}

		setItems(prevItems => {
			const _items = [...prevItems]
			_items.splice(_items.indexOf(item), 1)

			// If items are still in cart, add distributed amount of down payment of removed item
			if (_items.length) {
				return _items.map(_item => {
					return {
						..._item,
						downPayment: _item.downPayment + amountToAddToEveryItem
					}
				})
			}

			return _items
		})
	}

	const updateItem = (item: CartItem, updatedItem: CartItem) => {
		setItems(prevItems => {
			const _items = [...prevItems]
			_items[_items.indexOf(item)] = updatedItem
			return _items
		})
	}

	useEffect(() => {
		if ((!router.asPath.includes("/checkout/")) && items[0]?.isSponsored) {
			clearCart()
		}
	}, [router.asPath, router.query])

	useEffect(() => {
		// Update cart when window gets focus
		window.onfocus = () => {
			// SetItems(getCart())
		}
	}, [])

	useEffect(() => {
		storeCart(items)
	}, [items])

	const clearCart = () => {
		setItems([])
		storeCart([])
	}

	return (
		<CartContext.Provider value={{items, setItems, addItem, removeItem, storeCart, updateItem, clearCart}}>
			{children}
		</CartContext.Provider>
	)
}

CartContextProvider.propTypes = {
	children: PropTypes.node
}

export default CartContextProvider

